












import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
@Component({
  components: {}
})
export default class Condition extends Vue {
  @Prop() public msg!: string
  public show = true
  // public get allRules() {
  //   return this.$store.state.allRules
  // }
  // @Watch('allRules', { immediate: true, deep: true })
  // onRulesChange(val: any) {
  //   this.filterList = val
  // }
  // methods
  public loginHandler() {
    this.$store.commit('SET_LOGINMODAL', true)
  }
  public hideBanner() {
    this.show = false
  }
}
